import COUNTRY_CODES from "../../../../../utils/countryCodes";

/**
 * Unique list of countries for the country selector
 * Extracts unique countries from COUNTRY_CODES based on nameCode
 */
export const COUNTRIES_LIST = (() => {
  const seen = new Set();
  const countries = [];

  for (const item of COUNTRY_CODES) {
    if (seen.has(item.nameCode)) {
      continue;
    }

    seen.add(item.nameCode);
    countries.push({
      country: item.country,
      code: item.code,
      nameCode: item.nameCode,
    });
  }

  return countries.sort((a, b) => a.country.localeCompare(b.country));
})();

/**
 * Default country code for phone number parsing
 */
export const DEFAULT_COUNTRY_CODE = "MX";
